

























































































































































































































































































import { defineComponent, ref, computed } from "@vue/composition-api";
import FixedFooterLayout from "@/components/Atoms/Layout/FixedFooter/index.vue";
import OccAlertFloating from "@/components/Molecules/OccAlert/Floating/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import OccBreadcrumbs from "@/components/Atoms/OccBreadcrumbs/index.vue";

import { getEventEntryUsers, updateEventStatus } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import {
  getDisplayEventType,
  getDisplayEventStatus
} from "@/helpers/eventEntryUsers";
import { formatDate } from "@/helpers/date-helper";
import { useRoute, useRouter } from "@/router";

export default defineComponent({
  components: {
    FixedFooterLayout,
    OccAlertFloating,
    PageHeader,
    LoadingView,
    Button,
    Caption,
    ListTable,
    OccLabel,
    OccButton,
    ConfirmModal,
    OccBreadcrumbs
  },
  name: "EventEntryUsersEventStatus",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const eventId = route.params.eventId;
    const selectedEventStatus = route.query.eventStatus as string;
    const eventEntryUserIds = computed(() => {
      const ids = route.query.eventEntryUserIds as string;
      return ids.split(",").map(id => Number(id));
    });

    const [{ data: eventEntryUsers, loading: isGetLoading }] = useRequest(
      () =>
        getEventEntryUsers({
          eventId: eventId,
          entry_ids: eventEntryUserIds.value,
          limit: eventEntryUserIds.value.length,
          order: "desc"
        }),
      { immediate: true }
    );

    const validEventEntryUsers = computed(() => {
      if (!eventEntryUsers.value) return [];
      return eventEntryUsers.value.records.filter(record =>
        record.event.possible_transitions.includes(selectedEventStatus)
      );
    });
    const invalidEventEntryUsers = computed(() => {
      if (!eventEntryUsers.value) return [];
      return eventEntryUsers.value?.records.filter(
        record =>
          !record.event.possible_transitions.includes(selectedEventStatus)
      );
    });

    const headers = [
      {
        name: "イベント応募日時",
        sizeInner: "150px",
        minSizeContainer: "150px"
      },
      {
        name: "応募スケジュール",
        subHeaders: [{ name: "スケジュール開催日" }],
        minSizeContainer: "320px"
      },
      {
        name: "ユーザー名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "180px"
      },
      {
        name: "大学名",
        subHeaders: [{ name: "卒年" }, { name: "学部・学年" }],
        sizeInner: "100px",
        minSizeContainer: "220px"
      },
      {
        name: "変更前",
        sizeInner: "130px",
        minSizeContainer: "170px"
      },
      {
        name: "変更後",
        sizeInner: "130px",
        minSizeContainer: "170px"
      }
    ];

    const breadcrumbRoutes = computed(() => [
      {
        label: eventEntryUsers.value?.event.title,
        to: {
          name: "JobEvent",
          params: { event_id: String(eventEntryUsers.value?.event.id) }
        }
      },
      {
        label: "",
        to: {},
        disabled: true
      }
    ]);

    const getDisplayScheduleSpan = (date: { start: string; end: string }) => {
      if (date.start && date.end) {
        return `${formatDate(date.start)}〜${formatDate(date.end)}`;
      } else if (date.start) {
        return formatDate(date.start);
      } else {
        return formatDate(date.end);
      }
    };

    const visibleUpdateConfirmFloatingView = ref(false);
    const visibleUpdatedFloatingView = ref(false);

    const handleConfirm = () => {
      visibleUpdateConfirmFloatingView.value = true;
    };

    const handleCancel = () => {
      visibleUpdateConfirmFloatingView.value = false;
    };

    const backToEventEntryUsers = () => {
      router
        .push({
          name: "JobEventEntryUsers",
          params: { eventId: eventId }
        })
        .catch(err => err);
    };

    const [{ loading: isUpdateLoading }, runUpdateEventStatus] = useRequest(
      () =>
        updateEventStatus({
          entry_ids: eventEntryUserIds.value,
          event_status: selectedEventStatus
        }),
      { immediate: false }
    );

    const handleSubmit = () => {
      visibleUpdateConfirmFloatingView.value = false;
      runUpdateEventStatus();
      visibleUpdatedFloatingView.value = true;
    };

    const handleUpdated = () => {
      visibleUpdatedFloatingView.value = false;
      router
        .push({
          name: "JobEventEntryUsers",
          params: { eventId: eventId }
        })
        .catch(err => err);
    };

    return {
      selectedEventStatus,
      eventEntryUserIds,
      validEventEntryUsers,
      invalidEventEntryUsers,
      getDisplayEventType,
      getDisplayEventStatus,
      formatDate,

      eventEntryUsers,
      headers,
      breadcrumbRoutes,
      isGetLoading,

      getDisplayScheduleSpan,

      handleConfirm,
      backToEventEntryUsers,
      visibleUpdateConfirmFloatingView,
      visibleUpdatedFloatingView,
      handleUpdated,
      handleCancel,
      handleSubmit,
      isUpdateLoading
    };
  }
});
